import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { eur } from "@/lib/api";
import { PageHeader, Card } from "@/components/common";
import { AlertTriangle, Clock } from "lucide-react";

const FILTERS = [
  { key: "all", label: "Tutti" },
  { key: "scaduti", label: "Scaduti" },
  { key: "scadenza", label: "In scadenza" },
];

export default function AccontiSaldi() {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState(params.get("f") === "scaduti" ? "scaduti" : params.get("f") === "scadenza" ? "scadenza" : "all");

  useEffect(() => { api.get("/payment-dues").then((r) => setItems(r.data)); }, []);

  const setF = (k) => { setFilter(k); setParams(k === "all" ? {} : { f: k }); };
  const filtered = items.filter((o) => filter === "all" ? true : filter === "scaduti" ? o.overdue : o.upcoming);
  const nOver = items.filter((o) => o.overdue).length;
  const nUp = items.filter((o) => o.upcoming).length;

  return (
    <div>
      <PageHeader title="Acconti / Saldi" subtitle="Pagamenti scaduti o in scadenza — clicca una riga per aprire la prenotazione" />

      <div className="flex flex-wrap items-center gap-2 mb-4" data-testid="pay-filters">
        {FILTERS.map((f) => (
          <button key={f.key} data-testid={`pay-filter-${f.key}`} onClick={() => setF(f.key)}
            className={`text-sm font-semibold px-3 py-1.5 rounded-md border ${filter === f.key ? "bg-sky-600 text-white border-sky-600" : "bg-white text-slate-700 border-slate-300 hover:bg-slate-50"}`}>
            {f.label}
            {f.key === "scaduti" && nOver > 0 && <span className="ml-1.5 text-xs">({nOver})</span>}
            {f.key === "scadenza" && nUp > 0 && <span className="ml-1.5 text-xs">({nUp})</span>}
            {f.key === "all" && <span className="ml-1.5 text-xs">({items.length})</span>}
          </button>
        ))}
      </div>

      <Card className="p-0 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="pay-table">
            <thead>
              <tr className="text-[11px] uppercase text-slate-500 border-b border-slate-200 bg-slate-50">
                <th className="text-left px-4 py-2.5">Ospite</th>
                <th className="text-left px-3 py-2.5">Struttura · Camera</th>
                <th className="text-left px-3 py-2.5">Check-in</th>
                <th className="text-left px-3 py-2.5">Tipo</th>
                <th className="text-right px-3 py-2.5">Importo</th>
                <th className="text-left px-3 py-2.5">Scadenza</th>
                <th className="text-left px-4 py-2.5">Stato</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((o, i) => (
                <tr key={i} data-testid={`pay-row-${o.id}`} onClick={() => navigate(`/money?edit=${o.id}`)}
                  className={`border-b border-slate-100 cursor-pointer hover:bg-sky-50/50 ${o.overdue ? "bg-rose-50/50" : "bg-amber-50/40"}`}>
                  <td className="px-4 py-2.5 font-medium text-slate-800">{o.guest || "—"}</td>
                  <td className="px-3 py-2.5 text-slate-600">{o.structure ? `${o.structure} · ` : ""}{o.property}</td>
                  <td className="px-3 py-2.5 text-slate-600">{o.checkin}</td>
                  <td className="px-3 py-2.5"><span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${o.kind === "Acconto" ? "bg-indigo-50 text-indigo-700 border border-indigo-200" : "bg-teal-50 text-teal-700 border border-teal-200"}`}>{o.kind}</span></td>
                  <td className="px-3 py-2.5 text-right tabular font-medium">{eur(o.amount)}</td>
                  <td className="px-3 py-2.5 text-slate-600">{o.due}</td>
                  <td className="px-4 py-2.5">
                    {o.overdue
                      ? <span className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full bg-rose-100 text-rose-700 border border-rose-300"><AlertTriangle size={11} /> Scaduto</span>
                      : <span className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 border border-amber-300"><Clock size={11} /> {o.left === 0 ? "Scade oggi" : `Tra ${o.left} gg`}</span>}
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-400">Nessun pagamento in questa categoria</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
